import React, { ForwardedRef } from 'react';
import cn from "classnames";
import Loader from "components/Loader";

export type buttonStyles =
    "default"
    | "warning"
    | "success"
    | "danger"
    | "ghost"
    | "primary";

export type buttonSizes = "small" | "normal" | "large" | "wide";

export type ButtonProps = {
    style?: buttonStyles;
    colors?: {
        background: string;
        text: string;
    }
    backgroundColor?: string;
    className?: string;
    onClick?: any;
    label: string;
    disabled?: boolean;
    type?: "submit" | "button";
    pending?: boolean;
    iconOnly?: boolean;
    hidden?: boolean;
};

const Button = React.forwardRef((props: ButtonProps, ref: ForwardedRef<any>) => {
    const { label, onClick, disabled, type, pending } = props;

    const buttonCn = cn(
        "hover:bg-button/80 block bg-button text-btnTextColor transition-all active:shadow-primary-active py-2 px-4 rounded-md",
        { "cursor-not-allowed": disabled },
        props.className,
    );

    return (
        <button
            ref={ref}
            hidden={props.hidden}
            className={buttonCn}
            disabled={disabled || pending}
            type={type ? type : "button"}
            onClick={onClick}
        >
            {pending ? <Loader className={"size-6"}/> : <span dangerouslySetInnerHTML={{ __html: label }}/>}
        </button>
    );
});

Button.displayName = "Button";

export default Button;